import { ItemList } from '../orm'

class OutgoingFaxSettingsList extends ItemList {
    getEntityKey() {
        return "outgoing_fax_settings"
    }
}

export const outgoingFaxSettingsList = new OutgoingFaxSettingsList("outgoing_fax_settings__default")
